import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimalplaces',
})
export class DecimalplacesPipe implements PipeTransform {
  transform(value: number): any {
    return Number(value).toFixed(2);
  }
}



// WEBPACK FOOTER //
// ./src/app/decimalplaces.pipe.ts